import { useContext } from "react";
import { QuickApplyContext } from "../contexts/quick_apply_context";

export const useQuickApply = () => {
  return useContext(QuickApplyContext);
};
